// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Loader, Button, Toastr } from "@revvsales/components";
import { isValidPhoneNumber } from "react-phone-number-input";

// Components Imports
import SignerDetailsList from "./SignerDetailsList";
import SignerDetailsWithFillerOption from "./SignerDetailsWithFillerOption";

// Action Imports
import {
  addDocRecipientsAction,
  fetchDocRecipientListAction,
} from "../../../../actions/DocumentActions";

// Internal Imports
import { EVENTS } from "../../../../constants";
import { DocumentUtils, AmplitudeUtils, GlobalUtils } from "../../../../utils";
import SHIELD from "../../../../assets/ic-shield.svg";

const { amplitudeLogEvent } = AmplitudeUtils;
const { handleApiErrMsg } = GlobalUtils;
const { getExportContent } = DocumentUtils;

class SignerDetails extends Component {
  state = {
    errMsg: "",
    signersList: [],
    showLoader: false,
    fillersList: [],
    isTrue: false,
    fillerMessgae: false,
    docepientEmailMessage: "",
  };

  componentDidMount() {
    this._fetchSharedReviewerList();
  }

  _closePopup = state => {
    this.props.onClose(state);
  };

  _toggleCheckbox = i => {
    let data = [];
    let ButtonDisable = false;
    data = [...this.state.signersList];
    data[i].showOtp = !data[i].showOtp;
    // data[i].isPossible = false;
    if (data[i].showOtp) {
      ButtonDisable = true;
    }
    this.setState(() => ({ signersList: data, isTrue: ButtonDisable }));
  };

  _fetchSharedReviewerList = () => {
    const { document } = this.props;
    this.setState({
      showLoader: true,
    });
    this.props
      .fetchDocRecipientList(document.id)
      .then(response => {
        const { collaborators } = response;
        const data = [...collaborators];
        // Add the Signers and Default reviewer
        this._addSignerAndRecipientList(data);
      })
      .catch(() => {
        this._addSignerAndRecipientList([]);
        this.setState({
          showLoader: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _getDocumentHtml = () => {
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    const html =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    return html;
  };

  _generateEsignPayload = () => {
    const { signersList, fillerAccessList } = this.state;
    // Content for PDF
    const previewContent = getExportContent(
      this.props.document,
      this.props.components,
    );
    const signers = [];
    if (signersList.length > 0) {
      signersList.forEach((signer, i) => {
        signers.push({
          user_email: signer.user_email,
          first_name: signer.first_name,
          last_name: signer.last_name,
          recipientId: i + 1,
          mobile_number: signer.mobile_number,
          auth_type: signer.auth_type,
        });
      });
    }
    const data = {
      signers: [...signers],
      fillers: fillerAccessList,
      emailSubject: "",
      isReview: false,
      isEsign: true,
      esignType: "OS", // This is hard coded for now since we support only one esignature tool
      pdfFile: {},
    };
    data.pdfFile = previewContent;
    data.pdfFile.content.schema_version = "1.0";
    data.docName = this.props.document.name;
    data.pdfFile.content.htmlString = this._generateDocumentAsHtml();
    data.pdfFile.content.signers = [...signers];
    return data;
  };

  _onError = err => {
    this.setState({ showLoader: false });
    console.error(err);
    Toastr.showToastr({
      type: "failure",
      message: handleApiErrMsg(err),
      timeout: 3000,
    });
    amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
      Error: "Oops! Something went wrong. Please try again later.",
    });
  };

  _onSendForEsignClick = () => {
    const payload = this._getShareDocumentPayload();

    if (
      this.props.document.fields_used &&
      this.props.document.fields_used.length > 0
    ) {
      const newFiller = [];
      this.props.document.fields_used.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          newFiller.push(element);
        }
      });
      if (newFiller && newFiller.length > 0) {
        this.setState({ isTrue: true });
        if (payload.fillers && payload.fillers.length > 0) {
          this.setState({ isTrue: false });
        } else {
          this.setState({ fillerMessgae: true, isTrue: true });
          return;
        }
      }
    }
    this.setState({ showLoader: true });
    this.props
      .addDocRecipientsAction(this.props.document.id, payload, "isSigner")
      .then(() => {
        this.props.onClose({
          triggerNxt: true,
          showSignerDetailsModal: false,
        });
      })
      .catch(err => {
        this._onError(err);
      });
  };

  _addRemoveFiller = (shouldAdd, filler) => {
    const { fillersList } = this.state;
    if (shouldAdd) {
      this.setState({
        fillersList: [...fillersList, filler],
        isTrue: false,
        fillerMessgae: false,
      });
    } else {
      this.setState({
        fillersList: fillersList.filter(
          user => user.user_email !== filler.user_email,
        ),
        isTrue: false,
        fillerMessgae: false,
      });
    }
  };

  _getShareDocumentPayload = () => {
    const { signersList, fillersList, docepientEmailMessage } = this.state;
    // Content for PDF
    const previewContent = getExportContent(
      this.props.document,
      this.props.components,
    );
    const signers = [];
    if (signersList.length > 0) {
      signersList.forEach((signer, i) => {
        signers.push({
          user_email: signer.user_email,
          first_name: signer.first_name,
          last_name: signer.last_name,
          recipientId: i + 1,
          mobile_number: signer.mobile_number,
          auth_type: signer.auth_type,
        });
      });
    }

    const data = {
      signers: [...signers],
      fillers: fillersList,
      emailSubject: "",
      isReview: false,
      isEsign: true,
      esignType: "OS", // This is hard coded for now since we support only one esignature tool
      pdfFile: {},
      email_message: docepientEmailMessage.trim(),
    };
    data.pdfFile = previewContent;
    data.pdfFile.content.schema_version = "1.0";
    data.docName = this.props.document.name;
    data.pdfFile.content.htmlString = this._getDocumentHtml();
    data.pdfFile.content.signers = signers.reduce((accum, item) => {
      accum[item.user_email] = item;
      return accum;
    }, {});
    return data;
  };

  _addSignerAndRecipientList = () => {
    const signers = this._getSignerList();
    this.setState({
      showLoader: false,
      signersList: signers,
    });
  };

  showMenu = (event, i) => {
    event.preventDefault();
    let data = [];
    data = [...this.state.signersList];
    data[i].showAuth = !data[i].showAuth;
    // data[i].showOtp = false;
    this.setState(() => ({ signersList: data }));
  };

  _getSignerList = () => {
    const { signersAccessList } = this.props;
    const signers = [];
    if (signersAccessList && signersAccessList.length > 0) {
      signersAccessList.forEach(d => {
        const findSigner = signers.find(
          signer => signer.user_email === d.signerEmail,
        );
        if (!findSigner) {
          signers.push({
            user_email: d.signer_email,
            first_name: d.first_name,
            last_name: d.last_name,
            image_url: d.signer_config.image_url,
            role: "SIGNER",
          });
        }
      });
    }
    return signers;
  };

  numberValidation = (value, i) => {
    let ButtonTrue = true;
    let data = [];
    data = [...this.state.signersList];
    if (value && isValidPhoneNumber(value)) {
      data[i].isPossible = true;
      ButtonTrue = false;
    } else {
      data[i].isPossible = false;
      ButtonTrue = true;
    }
    this.setState(() => ({ signersList: data, isTrue: ButtonTrue }));
  };

  handlePhoneNumber = (event, i) => {
    let data = [];
    data = [...this.state.signersList];
    this.numberValidation(event, i);
    data[i].mobile_number = event;
    data[i].auth_type = "SMS";
    this.setState(() => ({ signersList: data }));
  };

  _editDocumentUpdate = () => {
    const { id: documentID } = this.props.document;
    this.props.editDocument(documentID);
    this._closePopup();
  };

  _handleDocrecipientMessageChange = e => {
    this.setState({
      docepientEmailMessage: e.target.value,
    });
  };

  _decideSignerDetailsView = () => {
    const { signersList } = this.state;
    if (signersList && signersList.length > 0) {
      const {
        showForm: isFormDocument,
        fields_used: fieldsUsed,
      } = this.props.document;
      const newFiller = [];
      fieldsUsed.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          newFiller.push(element);
        }
      });
      if (isFormDocument && newFiller.length > 0) {
        return (
          <SignerDetailsWithFillerOption
            fieldsUsed={fieldsUsed}
            signersList={this.state.signersList}
            updateFillerDetails={this._addRemoveFiller}
            showMenu={this.showMenu}
            handlePhoneNumber={this.handlePhoneNumber}
            toggleCheckbox={this._toggleCheckbox}
            fillerMessgae={this.state.fillerMessgae}
          />
        );
      }
      return (
        <SignerDetailsList
          signersList={this.state.signersList}
          showMenu={this.showMenu}
          handlePhoneNumber={this.handlePhoneNumber}
          toggleCheckbox={this._toggleCheckbox}
        />
      );
    }
    return null;
  };

  render() {
    const { showLoader, docepientEmailMessage } = this.state;

    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;
    return (
      <Modal
        open
        onClose={() => this._closePopup({ showSignerDetailsModal: false })}
        center
        closeOnOverlayClick={false}>
        {/* ----------- Loader Section ----------- */}
        {showLoader && (
          <Loader
            className="loader-bg-color"
            label="🔏 Processing your document for eSignature."
          />
        )}

        {/* ----------- Modal Heading Section ----------- */}
        <div className="docrecipientspopup-container">
          <div
            className="modal-heading"
            data-test="addrecipientspopup-modal-heading">
            All recipients below can sign the document
          </div>
          {errMsgSpace}
          {/* ----------- Added Signer List Section ----------- */}
          {this._decideSignerDetailsView()}

          {/* ------------ Personalise Email ---------- */}
          <div className="docrecipientpopup-personalise">
            <p className="docrecipientpopup-personalise-subheading">
              Personalise the email by adding a text message from you
            </p>
            <div className="docrecipientpopup-personalise-body">
              <textarea
                rows="5"
                value={docepientEmailMessage}
                onChange={this._handleDocrecipientMessageChange}
                data-test="docrecipientpopup-personalise-textarea"
                placeholder="Start typing your message here"
              />
            </div>
          </div>

          {/* ----------- Secure Badge Section ----------- */}
          <div className="emptysigner-popup-warning-section">
            <div>
              <img src={SHIELD} alt="Revvsales" className="legal-signer-icon" />
            </div>
            <div>
              <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div>
              <div className="emptysigner-popup-legal-subtitle">
                All documents sent for eSignature via Revv are in compliance
                with global e-signature laws.
              </div>
            </div>
          </div>
          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              id="addrecipientspopup-cancle-btn"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="addrecipientspopup-cancle-btn"
              onClick={() => {
                this.setState({ showBtnLoader: true });
                this._closePopup({ showMoveDocStageToDraftModal: true });
              }}
              isLoading={this.state.showBtnLoader}>
              Edit document
            </Button>
            <Button
              disabled={this.state.isTrue}
              id="addrecipientspopup-share-btn"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="addrecipientspopup-share-btn"
              onClick={this._onSendForEsignClick}>
              Send for eSign
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { components, document } = state.DocumentStore;
  const { dealTableId } = state.QuotationStore;
  const {
    columnDefs: columnDefObj = {},
    discount: discountObj = {},
    metaData,
    priceBook: priceBookObj = {},
    rowData: rowDataObj = {},
  } = state.DealTableStore;

  // Pick out the required data from redux
  const columnDefs = columnDefObj[dealTableId] || [];
  const discount = discountObj[dealTableId] || {};
  const priceBook = priceBookObj[dealTableId] || {};
  const rowData = rowDataObj[dealTableId] || [];

  return {
    columnDefs,
    components,
    discount,
    document,
    metaData,
    priceBook,
    rowData,
  };
};

const mapDispatchToProps = {
  addDocRecipientsAction,
  fetchDocRecipientList: fetchDocRecipientListAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignerDetails);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/SignerDetails/index.js